/**
 * Standard section wrapper for pump hub modules — consistent headers and feedback.
 */
export default function AdminPumpSectionShell({
  step = null,
  title,
  description = '',
  actions = null,
  feedback = null,
  children,
}) {
  return (
    <section className="admin-pump-section admin-pump-hub__module-content">
      <header className="admin-pump-section__head">
        <div className="admin-pump-section__head-text">
          {step != null && (
            <span className="admin-pump-section__step">Section {step}</span>
          )}
          <h2 className="admin-pump-section__title">{title}</h2>
          {description && <p className="admin-pump-section__desc">{description}</p>}
        </div>
        {actions && <div className="admin-pump-section__actions">{actions}</div>}
      </header>

      {feedback && (
        <div className={`admin-pump-section__feedback admin-pump-section__feedback--${feedback.tone || 'info'}`} role="status">
          {feedback.title && <strong className="d-block mb-1">{feedback.title}</strong>}
          <span>{feedback.message}</span>
        </div>
      )}

      <div className="admin-pump-section__body">{children}</div>
    </section>
  );
}
